import { combineReducers } from "redux"

import loginReducer from "Containers/Login/reducer"
import messagesReducer from "Containers/Messages/reducer"
import businessReducer from "Containers/BusinessInformations/reducer"
import pageListReducer from "Containers/PageList/reducer"
import pageReducer from "Containers/Page/reducer"
import widgetsReducer from "Containers/Widget/reducer"
import mainInformationReducer from "Containers/MainInformations/reducer"
import colorPalettesReducer from "Containers/ColorPalettes/reducer"
import adminConsoleReducer from "Containers/ConsoleAdminContainer/reducer"
import AdministrationReducer from "Containers/Administration/reducer"

import formulaireReducer from "./submoduleform/reducers"
import MSFReducer from "Containers/MSF/Cases/reducer.js"

const appReducer = combineReducers({
  colorPalettes: colorPalettesReducer,
  login: loginReducer,
  messages: messagesReducer,
  myBusiness: businessReducer,
  pageList: pageListReducer,
  page: pageReducer,
  widgets: widgetsReducer,
  mainInformations: mainInformationReducer,
  adminConsole: adminConsoleReducer,
  administration: AdministrationReducer,
  formulaireReducer,
  msf: MSFReducer,
})

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_USER") {
    window.localStorage.setItem("avatar", "")
    window.localStorage.removeItem("businessLogo")
    // Symmetric cleanup of auth-related keys posed at login —
    // sans ça, useAuth() retombe sur le fallback localStorage
    // (app_current_user_id) et renvoie true, ce qui fait que
    // PublicRoute redirige vers /home au lieu d'afficher /user.
    window.localStorage.removeItem("app_current_user_id")
    window.localStorage.removeItem("accessToken")
    state = undefined
    sessionStorage.clear()
  }

  return appReducer(state, action)
}

export default rootReducer
